import type { FragmentType } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { isEmpty } from '../empty'
import { RestaurantAccesses } from './RestaurantAccesses.frag'

export function makeAccessText(restaurant: FragmentType<typeof RestaurantAccesses>): string {
  const { accesses, area } = getFragmentData(RestaurantAccesses, restaurant)

  // アクセス情報がない場合は都道府県と表示地域名称を表示する
  if (isEmpty(accesses)) {
    return `${area.mediumName}/${area.displayName}`
  }

  const access = accesses[0]
  const accessText =
    access.__typename === 'RestaurantAccessTrain'
      ? `${access.station}駅 ${access.note}`
      : access.__typename === 'RestaurantAccessCar'
        ? `${access.note}`
        : ''
  return accessText
}
